import script from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./reportSmsNotification.vue?vue&type=script&setup=true&lang=js"

import "./reportSmsNotification.vue?vue&type=style&index=0&id=33954508&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33954508"]])

export default __exports__